import { useQuery } from '@tanstack/react-query'
import { getCutOffOverseasWarehouses, getCutOffWarehouses } from './apis'
import { SelectOptionType } from '@/components/content/SelectBoxTypes'

const PATH = ['common', 'warehouse']
const GET_CUTOFF_WAREHOUSES = [...PATH, 'GET_CUTOFF_WAREHOUSES'] as const
const GET_CUTOFF_OVERSEAS_WAREHOUSES = [...PATH, 'GET_CUTOFF_OVERSEAS_WAREHOUSES'] as const

/** 컷오프 대상 센터 목록 조회 */
export const useGetCutOffWarehouses = () => {
  const { data: rawData, ...rest } = useQuery({
    queryKey: GET_CUTOFF_WAREHOUSES,
    queryFn: getCutOffWarehouses,
    select: (res) => res.data.items,
  })

  const data = rawData ? [...rawData].sort((a, b) => a.warehouseName.localeCompare(b.warehouseName, 'ko')) : undefined

  const options: (SelectOptionType<string> & { module: string })[] =
    data?.map(({ warehouseCode, warehouseName, module }) => ({
      label: warehouseName,
      value: warehouseCode,
      module,
    })) ?? []

  return { data, options, ...rest }
}

/** 해외출고 관리 센터 목록 조회 */
export const useGetCutOffOverseasWarehouses = () => {
  const { data, ...rest } = useQuery({
    queryKey: GET_CUTOFF_OVERSEAS_WAREHOUSES,
    queryFn: getCutOffOverseasWarehouses,
    select: (res) => res.data.items,
  })

  const options: SelectOptionType<string>[] =
    data?.map(({ warehouseCode, warehouseName }) => ({
      label: warehouseName,
      value: warehouseCode,
    })) ?? []

  return { data, options, ...rest }
}
